<template>
  <v-container>
    <v-row>
      <v-col>
        <template>
          <v-file-input
            label="File input"
            ref="fileInput"
            accept="text/csv"
            outlined
            dense
            @change="readCSV"
          ></v-file-input>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="type === 'Зарплата'">
        <v-data-table
          :headers="headersSalary"
          :items="items"
          :items-per-page="5"
          class="elevation-1"
        >
          <template v-slot:item.obj="{ item }">
            <v-select
              v-model="item.obj"
              :items="obj"
              item-text="NAME"
              item-value="ID"
              label="Объект"
            ></v-select>
          </template>
        </v-data-table>
      </v-col>
      <v-col v-else>
        <v-data-table
          :headers="headersActs"
          :items="items"
          :items-per-page="5"
          class="elevation-1"
        >
          <template v-slot:item.obj="{ item }">
            <v-select
              v-model="item.obj"
              :items="obj"
              item-text="NAME"
              item-value="ID"
              label="Объект"
            ></v-select>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-btn color="success" text @click="save">Сохранить</v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn color="orange" text @click="clear">Очистить</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>ID созданных документов</v-card-title>
          <v-card-text v-for="(item, index) in result" :key="index">{{
            item
          }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "App",

  data() {
    return {
      type: "",
      inputFile: "",
      headersActs: [
        { text: "Дата документа", value: "date" },
        { text: "Номер документа", value: "number" },
        { text: "Контрагент", value: "client" },
        { text: "Договор", value: "contract" },
        { text: "Сумма начисления", value: "sum" },
        { text: "Объект", value: "obj" },
      ],
      headersSalary: [
        { text: "ФИО сотрудника", value: "name" },
        { text: "Тип начисления", value: "type" },
        { text: "Сумма начисления", value: "sum" },
        { text: "Объект", value: "obj" },
      ],
      items: [],
      result: [],
      obj: [],
      file: "",
      url: "https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/",
    };
  },
  methods: {
    async getObj() {
      try {
        this.obj = [];
        const params = {
          IBLOCK_TYPE_ID: "bitrix_processes",
          IBLOCK_ID: "41",
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const objData = await axios.post(this.url + method, params);
          next = objData.data.next;
          for (const elem of objData.data.result) {
            this.obj.push(elem);
          }
          if (!next) {
            i = 0;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    readCSV() {
      const file = this.$refs.fileInput.$refs.input.files[0];
      if (file) {
        new Promise(function(resolve, reject) {
          const reader = new FileReader();
          reader.onload = function(evt) {
            resolve(evt.target.result);
          };
          reader.readAsText(file);
          reader.onerror = reject;
        })
          .then(this.processFileContent)
          .catch(function(err) {
            console.log(err);
          });
      }
    },
    processFileContent(data) {
      this.file = data.split("\n");
      //console.log(this.file)
      this.setItems();
    },
    setItems() {
      this.type = this.file[0].split("\r")[0];
      this.file.splice(0, 1);
      for (const elem of this.file) {
        if (elem) {
          const elemAray = elem.split(",");
          if (this.type === "Зарплата") {
            const item = {
              sum: elemAray[1],
              obj: "",
              name: elemAray[0],
              type: elemAray[2],
            };
            this.items.push(item);
          } else {
            const item = {
              date: elemAray[0],
              number: elemAray[1],
              client: elemAray[2],
              contract: elemAray[3],
              sum: elemAray[4],
              obj: "",
            };
            this.items.push(item);
          }
        }
      }
    },
    clear() {
      this.items = [];
      this.file = "";
      this.inputFile = "";
    },
    async save() {
      try {
        let checked = false;
        for (let i = 0; i <= this.items.length - 1; i++) {
          console.log(this.items[i]);
          if (!this.items[i].obj) {
            alert("вы не везде заполнили объект");
            break;
          }
          if (i === this.items.length - 1) checked = true;
        }
        if (checked) {
          const date = new Date();
          const year = date.getFullYear();
          const month = date.getMonth();
          for (const elem of this.items) {
            console.log({ elem });
            const sum = elem.sum.replace(/\s+/g, "").trim();
            console.log(sum);
            const method = "lists.element.add";
            let params = {};
            if (this.type === "Зарплата") {
              params = {
                IBLOCK_TYPE_ID: "bitrix_processes",
                IBLOCK_ID: "55",
                ELEMENT_CODE: elem.type + elem.name + date,
                FIELDS: {
                  NAME: "Входящий счет",
                  PROPERTY_357: elem.obj,
                  PROPERTY_363: elem.type,
                  PROPERTY_377: sum,
                  PROPERTY_687: "27." + month + "." + year,
                  PROPERTY_379: 283,
                  PREVIEW_TEXT:
                    elem.type + " " + elem.name + " " + month + " " + year,
                  PROPERTY_355: 273,
                  PROPERTY_401: 305,
                  PROPERTY_385: 293,
                  PROPERTY_361: 277,
                  PROPERTY_387: 299,
                },
              };
            } else {
              params = {
                IBLOCK_TYPE_ID: "bitrix_processes",
                IBLOCK_ID: "55",
                ELEMENT_CODE: elem.number + elem.obj + date,
                FIELDS: {
                  NAME: "Приход денежных средств " + this.type,
                  PROPERTY_357: elem.obj,
                  PROPERTY_359: elem.number,
                  PROPERTY_687: elem.date,
                  PROPERTY_987: elem.client,
                  PROPERTY_977: sum,
                  PROPERTY_1053: 1405, //статус не проведен!
                },
              };
            }
            console.log({ params });
            const result = await axios.post(this.url + method, params);
            await axios.post(this.url + "bizproc.workflow.start", {
              TEMPLATE_ID: 85,
              DOCUMENT_ID: ["lists", "BizprocDocument", result.data.result],
              PARAMETERS: null,
            });
            this.result.push(result.data.result);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getObj();
  },
};
</script>
